import * as Effects from 'redux-saga/effects'
import { put } from 'redux-saga/effects'
import { getUserObjectId } from '../../reducers/userObject/selectors/object'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import { fireToastSuccess } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import { savePhotos } from '../../models/Photos'
import loadPhotos from '../../models/Photos/loadPhotos'
import deletePhotos from '../../models/Photos/deletePhotos'
import sortPhotos from '../../models/Photos/sortPhotos'

function* save(action) {
  const objectId = yield Effects.select(getUserObjectId)

  try {
    const actionNames = fetchActionsName(ActionNames.SavePhotos)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(callFetch(actionNames.input, actionNames.output, savePhotos)),
    ])

    const photos: any = yield Effects.call(
      service,
      action.pictures,
      action.room,
      objectId,
    )

    yield Effects.put({
      photos,
      type: 'room photos accepted',
    })
    yield put(fireToastSuccess(i18n.t('BBO_2857_image_deleted')))
  } catch (e) {
    console.error(e)
  }
}

function* load() {
  const objectId = yield Effects.select(getUserObjectId)

  if (objectId === undefined) {
    yield Effects.delay(500)
    yield Effects.put({ type: 'request room pictures' })
    return
  }

  try {
    const actionNames = fetchActionsName(ActionNames.SavePhotos)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(callFetch(actionNames.input, actionNames.output, loadPhotos)),
    ])

    const photos: any = yield Effects.call(service, objectId)

    yield Effects.put({
      photos,
      type: 'room photos accepted',
    })
  } catch (e) {
    console.error(e)
  }
}

function* deletePicture(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.SavePhotos)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, deletePhotos),
      ),
    ])

    const photos: any = yield Effects.call(
      service,
      action.picture.id,
      action.objectId,
    )

    yield Effects.put({
      photos,
      type: 'room photos accepted',
    })
    yield put(fireToastSuccess(i18n.t('BBO_2857_image_deleted')))
  } catch (e) {
    console.error(e)
  }
}

function* sort(action) {
  const objectId = yield Effects.select(getUserObjectId)
  try {
    const actionNames = fetchActionsName(ActionNames.SavePhotos)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(callFetch(actionNames.input, actionNames.output, sortPhotos)),
    ])

    const photos: any = yield Effects.call(
      service,
      action.pictures,
      objectId,
      action.id_room,
    )

    yield Effects.put({
      photos,
      type: 'room photos accepted',
    })
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeEvery('Save room pictures', save)
  yield Effects.takeEvery('request room pictures', load)
  yield Effects.takeEvery('remove room photo', deletePicture)
  yield Effects.takeEvery('sort room images', sort)
}
